module.exports = __webpack_public_path__ + "media/images/home/testimonials/shannon-bd7ae978c3f35d174a3b85f393a01b6a.jpg";